import { useMemo } from 'react'
import { t } from '@/i18n'

export const useTaskDetailData = (
  taskInfo: any,
  resourceFilterData: any,
  attckList: any,
  tagTreeOptions: any,
) => {
  // 任务评分
  const taskScore = useMemo(
    () => ({
      score: 0,
      risk_level: '',
    }),
    [],
  )

  // 转换任务信息
  const convertTaskInfo = useMemo(
    () => ({
      ...taskInfo,
      progress_rate:
        taskInfo?.is_finished === 3 || taskInfo?.is_finished === 4
          ? 100
          : taskInfo?.is_finished === 2
          ? 50
          : 0,
    }),
    [taskInfo],
  )

  // 进度信息
  const progressInfo = useMemo(
    () => ({
      ...taskInfo,
    }),
    [taskInfo],
  )

  // 标签树数据
  const tagTreeData = useMemo(() => {
    const listMappings = [
      {
        title: t('用例分级'),
        list: resourceFilterData?.caseLevelList || [],
        total: resourceFilterData?.caseLevelTotal || 0,
        key: 'resourceLevel',
      },
      {
        title: t('危险等级'),
        list: resourceFilterData?.riskLevelList || [],
        total: resourceFilterData?.riskLevelTotal || 0,
        key: 'tree_risk_level',
      },
      {
        title: t('验证结果'),
        list: resourceFilterData?.resourceStatusList || [],
        total: resourceFilterData?.resourceStatusTotal || 0,
        key: 'tree_intercept_status',
      },
      {
        title: t('安全设备'),
        list: resourceFilterData?.deviceList || [],
        total: resourceFilterData?.deviceTotal || 0,
        key: 'tree_device_ids',
      },
    ]
    return listMappings.map(category => ({
      title: category.title,
      key: category.key,
      extra: category.total,
      children: category.list.map(item => ({
        title: item.fieldName,
        key: `${category.key}_${item.fieldId}`,
        extra: item.resourceCount,
      })),
    }))
  }, [resourceFilterData])

  return {
    taskScore,
    convertTaskInfo,
    progressInfo,
    tagTreeData,
  }
}
